export default __webpack_public_path__ + "web/react/components/branch-link/images/icon-large.e8f7e71be2d66ec5630fb9ba39d8c370.png";